export default __webpack_public_path__ + "static/media/footer-insta.065fbba7.svg";